import { render, staticRenderFns } from "./PopupDestinationUsers.vue?vue&type=template&id=515c6b8f"
import script from "./PopupDestinationUsers.vue?vue&type=script&lang=js"
export * from "./PopupDestinationUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports